import GeneralFilter from "../GeneralFilter";

function QuotationFilter() {
  return <GeneralFilter />;
}

export default QuotationFilter;
